import React from 'react';
import styled from 'styled-components';

const ExitModalButtonsStyled = styled.span`
  display: inline-block;


  padding: 0px 18px;
  overflow: hidden;

  border: 0px #c6cacf solid;
  border-left: 1px solid #d5d7da;

  color: #000;

  > label {
    cursor: pointer;
    display: inline-block;
    height: 30px;
    background: white;
    border-radius: 5px 5px 5px 5px;

    > input {
      display: none;
    }

    > input + div {
      // border: 1px #c6cacf solid;
    }

    &:first-of-type > input + div {
      border-radius: 5px 0 0 5px;
    }

    &:last-of-type > input + div {
      border-radius: 0 5px 5px 0;
      border-left: none;
      width: 35px;
    }

    > input:checked + div {
      background: #000000;
      // border-color: #067fff;
      
      > span {
        color: #fff;
      }
    }

    &:first-of-type > input:checked + div {
      
    }

    > div {
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 10px;
    }
  }
`;

const ExitModalButtons = (props) => {

  const handleChangeEnabled = (e) => {
    props.onChangeEnabled(e.target.checked);
  }

  const handleChangeView = (e) => {
    props.onChangeView(e.target.checked);
  }

  return (
    <ExitModalButtonsStyled>
      <label>
        <input
          type="checkbox"
          checked={props.isModalOpened}
          onChange={handleChangeView}
        />
        <div>
          <span>POP UP</span>
        </div>
      </label>
      <label>
        <input
          type="checkbox"
          checked={props.isModalEnabled}
          onChange={handleChangeEnabled}
        />
        <div>
          <span>
            {props.isModalEnabled ? 'On' : 'Off'}
          </span>
        </div>
      </label>
    </ExitModalButtonsStyled>
  );
};

export default ExitModalButtons;
